import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useMappingChartsDataContext } from './hooks/useMappingChartsDataContext';

export const RegistersHoseHoldByTeam = () => {
    const { chartData } = useMappingChartsDataContext();

    return (
        <Donut
            title={'Atualização dos Cadastros Domiciliares por Equipe'}
            subtitles={chartData?.registersHoseHoldByTeam?.map((item) => item.description)}
            chartData={chartData?.registersHoseHoldByTeam || []}
            colors={defaultColors.slice(0, chartData?.registersHoseHoldByTeam?.length) || []}
            height={350}
        />
    );
};
